// src/pages/components/InvoiceTable.js
import React from "react";
import ReactDataGridCustom from "../../../components/customComponents/ReactDataGridCustom";
import { Card } from "react-bootstrap";
import { euroFormat } from "../../../utils/usefullFunctions";

const InvoiceTable = ({ title, columns, data, user, defaultLimit = 10, filterValue, onFilterValueChange, totaalOpenstaand = 0 }) => {
    // Create a new columns array that includes user as a prop in each column
    const columnsWithUser = columns.map(column => ({
        ...column,
        render: column.render
            ? (data) => column.render({ ...data, user }) // Pass user as part of the render context
            : undefined,
    }));

    return (
        <Card>
            <Card.Header>
                <Card.Title className="d-flex justify-content-between">
                    <h3 className="mb-0">
                        {title} ({data.length})
                        {totaalOpenstaand > 0 && <span> {euroFormat(totaalOpenstaand)}</span>}
                    </h3>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <ReactDataGridCustom
                    idProperty="project_id"
                    dataSource={data}
                    columns={columnsWithUser}  // Pass columnsWithUser here
                    pagination
                    defaultLimit={defaultLimit}
                    filterValue={filterValue}
                    onFilterValueChange={onFilterValueChange}
                />
            </Card.Body>
        </Card>
    );
};

export default InvoiceTable;
